/**
 * Trang 404 - Link không tồn tại
 * Hiển thị thông báo kèm đếm ngược để redirect:
 * - Chưa đăng nhập: về trang chủ (/)
 * - Đã đăng nhập: về trang điều khiển theo vai trò (giáo viên, phụ huynh, học sinh)
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, ExclamationTriangleIcon } from './common/Icons';
import Card from './common/Card';

const DASHBOARD_BY_ROLE: Record<string, string> = {
  teacher: '/cong-cu-giao-vien',
  parent: '/bang-dieu-khien-phu-huynh',
  student: '/lo-trinh-hoc-tap',
};

const COUNTDOWN_SECONDS = 10;

function NotFound404({ user }: { user: any }) {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  const redirectPath = user?.role && DASHBOARD_BY_ROLE[user.role]
    ? DASHBOARD_BY_ROLE[user.role]
    : '/';

  useEffect(() => {
    if (countdown <= 0) {
      navigate(redirectPath, { replace: true });
      return;
    }
    const timer = setInterval(() => setCountdown((c) => c - 1), 1000);
    return () => clearInterval(timer);
  }, [countdown, navigate, redirectPath]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="w-20 h-20 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <ExclamationTriangleIcon className="h-10 w-10" />
        </div>
        <h1 className="text-4xl font-black text-slate-800 mb-2">404</h1>
        <h2 className="text-xl font-bold text-slate-700 mb-2">Trang không tồn tại</h2>
        <p className="text-slate-500 text-sm mb-6">
          Link bạn truy cập không hợp lệ hoặc đã bị xóa. Bạn sẽ được chuyển hướng tự động sau:
        </p>
        <div className="text-4xl font-black text-teal-600 mb-6 tabular-nums">
          {countdown}
        </div>
        <p className="text-slate-400 text-xs mb-6">
          {user
            ? `Về trang điều khiển ${user.role === 'teacher' ? 'giáo viên' : user.role === 'parent' ? 'phụ huynh' : 'học sinh'}`
            : 'Về trang chủ'}
        </p>
        <button
          onClick={() => navigate(redirectPath, { replace: true })}
          className="w-full py-3 bg-teal-600 text-white font-bold rounded-xl hover:bg-teal-700 transition-colors flex items-center justify-center gap-2"
        >
          <HomeIcon className="h-5 w-5" />
          Về trang chủ ngay
        </button>
      </Card>
    </div>
  );
}

export default NotFound404;
